"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    background: ", ";\n    margin-bottom: ", "em;\n    padding: ", "em;\n    border: ", ";\n    color: ", ";\n"], ["\n    background: ", ";\n    margin-bottom: ", "em;\n    padding: ", "em;\n    border: ", ";\n    color: ", ";\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactDropzone = require("react-dropzone");

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var type = function type(props) {
    return props.type ? props.type : props.theme.dropzone.default;
};
var dropzone = function dropzone(props) {
    return props.theme.dropzone.types[type(props)];
};

var StyledDropzone = (0, _styledComponents2.default)(_reactDropzone2.default)(_templateObject, function (props) {
    return dropzone(props).background;
}, function (props) {
    return dropzone(props).margin;
}, function (props) {
    return dropzone(props).padding;
}, function (props) {
    return dropzone(props).border;
}, function (props) {
    return dropzone(props).color;
});

StyledDropzone.displayName = "StyledDropzone";

StyledDropzone.propTypes = {
    type: _propTypes2.default.string
};

exports.default = (0, _styledComponents.withTheme)(StyledDropzone);


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/styledDropzone.js
// module id = 1017
// module chunks = 95715928098905 168707334958949